import * as XLSX from "sheetjs-style";

const ExportExcel = (props) => {
  // Function to flatten nested objects
  const flattenData = (data, columns) => {
    return data.map((item) => {
      const flattenedItem = {};
      columns.forEach((column) => {
        const keys = column.split("."); // Handle nested keys using dot notation
        let value = item;

        keys.forEach((key) => {
          if (value && value.hasOwnProperty(key)) {
            value = value[key];
          } else {
            value = undefined; // Set to undefined if the key does not exist
          }
        });

        flattenedItem[column] = value; // Assign value to the flattened item
      });
      return flattenedItem;
    });
  };

  const exportToExcel = () => {
    if (!Array.isArray(props.data) || props.data.length === 0) {
      console.error(
        "No data available to export or data is not in the correct format."
      );
      return;
    }

    const flattenedData = flattenData(props.data, props.columns); // Flatten the data based on columns

    const worksheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook = XLSX.utils.book_new(); // Correcting the function call
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, props.fileName || "my-data.xlsx");
  };

  return (
    <button
      style={{ margin: "0" }}
      className="btnPrimary"
      onClick={exportToExcel}
    >
      Export to Excel
    </button>
  );
};

export default ExportExcel;
